module.exports = __webpack_public_path__ + "img/arrow_tiny.10f196c5.svg";